import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';
import { Responsive, WidthProvider } from 'react-grid-layout';
import { WIDGET_DETAILS_BY_WIDGET_TYPE } from '../views/constants/widgetConstants';
import { WIDGET_TYPE } from '../views/constants/perspectiveConstants';

const ResponsiveGridLayout = WidthProvider(Responsive);
// const WIDTH = 1200;
const ROW_HEIGHT = 8;
const COLS = 12;


const useStyles = makeStyles((theme) => ({
  gridLayout: {
    width: '100%',
    '& .react-resizable-handle': {
      opacity: 0,
      background: 'none',
      borderRight: `1px solid ${theme.palette.secondary.contrastText}`,
      borderBottom: `1px solid ${theme.palette.secondary.contrastText}`,
      width: theme.spacing(1),
      height: theme.spacing(1),
    }
  },
  fullHeight: {
    height: '100%',
  },
  dragging: {
    '& .react-grid-item': {
      backgroundColor: 'rgba(40, 44, 52, 0.8)', // theme.palette.background.paper
    },
    '& .react-grid-item.react-grid-placeholder': {
      backgroundColor: 'rgb(76,175,80, 0.2)', /* theme.palette.success.main */
    },
    '& .react-draggable-dragging': {
      backgroundColor: 'transparent',
    },
  },
  display: {
    '& .react-resizable-handle': {
      display: 'none'
    },
  },
  notDisplay: {
    '& .react-grid-item': {
      '&:hover .react-resizable-handle': {
        opacity: 1,
        transition: theme.transitions.create('opacity', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen
        }),
      },
      '&:hover': {
        backgroundColor: 'rgb(76,175,80, 0.2)',
        transition: theme.transitions.create('background-color', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen
        }),
      }
    },
  }
}));

const GridLayout = ({
  widgets,
  renderWidget,
  isDragging,
  isDisplay,
  fullHeight,
  droppingItem,
  ...props
}: any) => {
  const classes = useStyles();
  const _widgets = widgets.map((_widget: any) => ({
    i: _widget.id.toString(),
    x: _widget.x,
    y: _widget.y,
    w: _widget.width,
    h: _widget.height
  }));
  const layouts = {
    xxs: _widgets,
  };

  return (
    <ResponsiveGridLayout
      className={clsx('layout', classes.gridLayout, {
        [classes.dragging]: isDragging,
        [classes.display]: isDisplay,
        [classes.notDisplay]: !isDisplay,
        [classes.fullHeight]: fullHeight,
      })}
      preventCollision
      layouts={layouts}
      breakpoints={{
        xxs: 0
      }}
      cols={{
        xxs: 12
      }}
      rowHeight={ROW_HEIGHT}
      verticalCompact={false}
      droppingItem={droppingItem}
      {...props}
    >
      {widgets.map((_widget: any) => renderWidget(_widget))}
    </ResponsiveGridLayout>
  );
};

export default GridLayout;
